<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Button, Modal, Container, ButtonV2 } from '@Shelly/shelly-design-system';

	import ConfirmEmail from './ConfirmEmail.svelte';
	import { createEventDispatcher, onMount } from 'svelte';
	import { mobile } from 'src/services/mobile-rework';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let showModal = false;
	export let priority = 100;

	const dispatch = createEventDispatcher();

	let confirmEmailRef;
	let request = false;
	let requestIsSent = false;

	const toastEmailValidationMessage = $format('validation_active_toast_from_premium', {
		default: 'Your email was successfully validated. You can now subscribe.',
	});

	const handleCloseModal = () => dispatch('close');

	const closeModalOnAndroidBack = (e: CustomEvent) => {
		if (showModal) {
			e.preventDefault();
			handleCloseModal();
		}
	};

	onMount(() => {
		if (mobile.isMobile) {
			mobile.addEventListener('back_button', closeModalOnAndroidBack);
			return () => mobile.removeEventListener('back_button', closeModalOnAndroidBack);
		}
	});
</script>

<Modal
	on:close={handleCloseModal}
	{showModal}
	title={$format('validate_modal_prompt', {
		default: 'Please validate your e-mail.',
	})}
	backdropClose={true}
	removeScrollPadding
	zIndex={priority}
>
	<div slot="content" class="content-container">
		<Container padding="scrollPaddings">
			<ConfirmEmail
				inModal
				bind:request
				bind:requestIsSent
				bind:this={confirmEmailRef}
				on:close={handleCloseModal}
				{toastEmailValidationMessage}
				overrideMessage={$format('alert_verify_email_from_premium', {
					default: 'To enable Premium subscription, you need to confirm your e-mail is active',
				})}
			/>
		</Container>
	</div>

	<div slot="footer" class="d-flex justify-content-end">
		{#if !$showNewLayout}
			<Button
				loading={requestIsSent}
				disabled={requestIsSent}
				size="m"
				class="width-md-auto width-sm-full"
				variant="primary"
				on:click={() => confirmEmailRef.handleRequestCode()}
			>
				{$format('button_request_confirmation_code')}
			</Button>
		{:else}
			<ButtonV2
				loading={requestIsSent}
				disabled={requestIsSent}
				size="m"
				class="width-md-auto width-sm-full"
				variant="primary"
				on:click={() => confirmEmailRef.handleRequestCode()}
			>
				{$format('button_request_confirmation_code')}
			</ButtonV2>
		{/if}
	</div>
</Modal>
